import { LoadingBlurDiv } from "@shared/components";

import { useAdminUsersUrlQuery } from "../api/admin-user";
import { AdminUsersTab } from "../components/organisms";

const AdminUsersPage = () => {
  const { query, setFilters, resetFilters, currentFilters } =
    useAdminUsersUrlQuery();

  return (
    <LoadingBlurDiv isLoading={query.isFetching}>
      <AdminUsersTab
        users={query.data?.data || []}
        paginatedMeta={query.data?.meta}
        isLoading={query.isFetching}
        onFilter={setFilters}
        onClearFilter={resetFilters}
        initialFilters={currentFilters}
      />
    </LoadingBlurDiv>
  );
};

export default AdminUsersPage;
